module.exports = __webpack_public_path__ + "static/media/gif2.6759b6a8.gif";